import { ProdutoPrecoEditPopupComponent } from './produto-preco-edit-popup.component';
import { Parameters } from './../../../../../shared/interfaces/parameters';
import { ListaPreco } from 'app/shared/interfaces/lista-preco';
import { Preco } from 'app/shared/interfaces/preco';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ListaPrecoTabela } from 'app/shared/interfaces/lista-preco-tabela';
import { ListaPrecoService } from 'app/shared/services/lista-preco.service';
import { ListaPrecoTabelaService } from 'app/shared/services/lista-preco-tabela.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { ParametroService } from 'app/shared/services/parametro.service';

@Component({
  selector: 'app-produto-preco-popup',
  templateUrl: './produto-preco-popup.component.html',
  styleUrls: ['./produto-preco-popup.component.scss']
})
export class ProdutoPrecoPopupComponent implements OnInit {

  produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;
  selectedListaPreco: ListaPreco;
  selectedTabelaPreco: ListaPrecoTabela;

  novoPreco = {} as Preco; 
  precos: Preco[];
  precos$: BehaviorSubject<Preco[]> = new BehaviorSubject<Preco[]>(null);
  listaPrecos: ListaPreco[];
  tabelas$: BehaviorSubject<ListaPrecoTabela[]> = new BehaviorSubject<ListaPrecoTabela[]>(null);
  parameters: Parameters;

  /**
  * Ao Teclar Esc
  */
  // @HostListener('window:keyup.esc') onKeyUp() {
  //   if (this.dialog.openDialogs.length > 0) {
  //     console.log('@HostListener(window:keyup.esc) onKeyUp()');
  //     this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
  //       .subscribe(res => {
  //         if (res) {
  //           this.dialogRef.close();
  //         }
  //       });
  //   }
  // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoPrecoPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private listaPrecoService: ListaPrecoService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authService: JwtAuthService,
    private loader: AppLoaderService,
    private parametroService: ParametroService,

  ) { }


  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;
    console.log(`Produto: ${this.produto.codigo} - ${this.produto.descricao}`);


    this.authService.getItem().subscribe((i) => {
      console
      this.parametroService.getParametros(Number(i.filialId)).subscribe(
        (parametros) => {
          // console.log(`param i.filialId >>> \n ${JSON.stringify(i.filialId)}`);
          this.parameters = parametros;
          // console.log(`parameters >>> \n ${JSON.stringify(this.parameters)}`);
          this.listaPrecoService.getListaPreco(this.parameters.fatListaPrecoPadrao).subscribe(
            listaPadrao => {
              this.selectedListaPreco = listaPadrao;
              
              this.buildProdutoForm(this.produto);
            });
  
        },
        (error) => {
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO CARREGANDO PARAMETROS ... ${error}`,
              error: true
            });
  
        });
    });

    

    this.listaPrecoService.getListasPreco(1, 100).subscribe(lista => this.listaPrecos = lista);


    this.precos$.subscribe(precos=>this.precos = precos);

    this.precos$.next(this.produto.precos);

    // this.buildProdutoForm(this.produto);



  }

  buildProdutoForm(produto: Produto) {
    this.produtoForm = this.fb.group({
      lista: [this.selectedListaPreco],
      tabela: [this.selectedTabelaPreco],
    })

  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }


  changeLista() {
    this.tabelaPrecoService.getListaPrecoTabela(this.selectedListaPreco?.id).subscribe(tabelas => this.tabelas$.next(tabelas));
  }

  deletePreco(preco: Preco) {
    this.confirmService.confirm({ message: `Deseja realmente deletar o preço [${preco?.preco} - ${preco?.listaPreco?.descricao} - ${preco?.tabela?.descricao}]` })
      .subscribe(res => {
        if (res) {
          this.produtoService.deleteProdutoPreco(this.produto.id, preco.listaPreco.id, preco.tabela.id.tabelaId)
            .subscribe(precos => {
              this.precos = precos;
              this.precos$.next(precos);
            });
        }
      });
  }


  submit() {
    if (this.produtoForm.valid) {
      console.log('form submitted');
      this.save();
    } else {
      this.validateAllFormFields(this.produtoForm); // {7}
    }
  }

  save(): BehaviorSubject<Produto> {
    this.produtoForm.patchValue({ classfiscalId: this.produtoForm['classfiscalId'] });
    this.produtoForm.patchValue({ classfiscalEntradaId: this.produtoForm['classfiscalEntradaId'] });
    const result = new BehaviorSubject<Produto>(null);
    this.produtoService.saveOrUpdate(this.produtoForm.value).subscribe(
      val => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Precos Salvo com Sucesso!', error: true
        });
        result.next(val);
      },
      err => {
        result.error(err);
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR, VERIFIQUE',
          message: err.error.status, error: true
        })
      });
    return result;
  }

    
  incluirPreco(preco: Preco) {
    const lista  = this.produtoForm.controls['lista'].value; 
    const tabela = this.produtoForm.controls['tabela'].value;
    
    if (tabela === undefined || tabela === null || tabela === '') {
      this.confirmService.confirm(
        {
          title: `A T E N Ç Ã O !`,
          message: `Tabela Preço não Selecionada. Selecione uma Tabela Preço e click em Adicionar !`,
          error: true
        }
      );
      return;

    }
    
    const tabelaFound = this.precos.find((reg) => reg.listaId === lista.id && reg.tabelaId === tabela.id.tabelaId );
    if(tabelaFound !== undefined){
      this.confirmService.confirm(
        {
          title: `A T E N Ç Ã O !`,
          message: `Tabela de Preço já Adicionada. Selecione outro Tabela de Preço e click em Adicionar !`,
          error: true
        }
      );
      return;
    }

    
    // this.produtoForm.patchValue({ selectedTabelaPreco: null });

    preco = {} as Preco;
    preco.produtoId = this.produto.id;
    preco.listaId = tabela.listaId;
    preco.tabelaId = tabela.tabelaId;
    preco.listaPreco = lista;
    preco.tabela = tabela;
    preco.preco = 0.0

    this.precos.push(preco);

    this.produtoService.saveOrUpdatePrecos(this.precos).subscribe(
      (precos) => {
        this.precos$.next(precos)
        this.produto.precos = precos;
        this.confirmService.confirm(
          {
            title: `S U C E S S O  !`,
            message: `Produto Atualizado com Sucesso !`,
            error: false
          }
        );
        
      },
      (err) => {

        this.confirmService.confirm(
          {
            title: `A T E N Ç Ã O !`,
            message: `Não foi Possível Aatualizar Produto!`,
            error: true
          }
        );
      });
    

    return;
  }

  openProdutoPrecoPopUp(preco: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    let title = "PREÇO: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoPrecoEditPopupComponent, {
      width: this.layout.isMobile ? '98%' : '40%',
      disableClose: true,
      data: { title: title + "[ "+ this.produto.codigo + " - " + this.produto.descricao +" ] - [ "+ preco.listaPreco.descricao + " Tab.:" + preco.tabela.codigo + " ]", payload: preco }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        this.produtoService.getPrecos(this.produto.id).subscribe(precos=>this.precos$.next(precos));
        if (!res) {
          return;
        }
        this.loader.open();
      })
  }

  close() {
    this.dialogRef.close();
  }

}
